import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=51b0e8d6"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=51b0e8d6&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b0e8d6')) {
      api.createRecord('51b0e8d6', component.options)
    } else {
      api.reload('51b0e8d6', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=51b0e8d6", function () {
      api.rerender('51b0e8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/driver/components/tableData.vue"
export default component.exports